import React, { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "../VendorFollowUp.scss";
import "ag-grid-enterprise"; // Import Ag-Grid Enterprise features
import "ag-grid-enterprise/styles/ag-grid.css";
import "ag-grid-enterprise/styles/ag-theme-quartz.css";
import 'ag-grid-enterprise/styles/ag-theme-alpine.css';
import { useNavigate } from "react-router-dom";
import UploadContactsModal from "./UploadContactModel/UploadContactsModal";
import MainContentVendor from "./VendorScore/pages/demo/MainContent/MainContent";
import { roleInfo, workspaceInfo } from "app/config/States/users";
import { useRecoilState } from "recoil";
import { Button, Modal } from "antd";
import PrimaryNavBhilosa from "app/shared/PrimaryNavBhilosa";
import { API_ENDPOINT_CONTACT_DETAILS } from "../vendorfollowup.constants";

const ContactDetailsTable = () => {
  const [vendorData, setVendorData] = useState([]);
  const gridApiRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [workspace, setWorkspace] = useRecoilState(workspaceInfo);
  const [selectedRow, setSelectedRow] = useState("")
  const workspace_name = localStorage.getItem("name");





  const columnDefsContactDetails = [
    {
      headerName: "Vendor Name", field: "vendorName", sortable: true, flex: 1, minWidth: 500, // Ensures it doesn't shrink too much
      maxWidth: 1000, headerCheckboxSelection: true, checkboxSelection: true,
      cellStyle: { color: "#0A8394", textDecoration: "underline" }
    },
    { headerName: "PAN", field: "pan", sortable: true, },
    { headerName: "GSTIN", field: "gstin", sortable: true, },
    {
      headerName: "E-invoice Eligible",
      field: "enablement_gov.einvStatus",
      cellRenderer: renderEInvoice,
      valueFormatter: (params) =>
        params.value === "Y" ? "true" : params.value === "N" ? "false" : "Unknown",
      sortable: true,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: ["true", "false"], // what appears in the filter UI
        valueFormatter: (value) => {
          if (value === "Y") return "true";
          if (value === "N") return "false";
        },
      },
    },
    
    {
      headerName: "Trade Name",
      field: "enablement_gov.tradeName",
      sortable: true,

      width: 300,
    },
    {
      headerName: "Email",
      field: "contactEmail",
      sortable: true,

    },
    {
      headerName: "HSN Codes",
      field: "HSN.bzgddtls",
      valueGetter: (params) =>
        params.data?.HSN?.bzgddtls
          ?.map((item) => `${item.hsncd} (${item.gdes})`)
          .join(", ") || "N/A",
      sortable: true,
      width: 500,
      cellRenderer: renderHSN
    },
  ];

  function renderEInvoice(params) {
    if (params.value === 'Y') {
      return (
        <span className="eligiblestatus">
          <span className="dot green"></span> True
        </span>
      );
    } else if (params.value === 'N') {
      return (
        <span className="eligiblestatus">
          <span className="dot red"></span> False
        </span>
      );
    }
    else if (params.value === 'Einvoice Exempt') {
      return (
        <span className="eligiblestatus">
          <span className="dot orange"></span> Exempt
        </span>
      );
    }
    return null; // Default case when value is not 'Yes' or 'No'
  }


  function renderHSN(params) {
    if (!params.data || !params.data.HSN) {
      console.log("HSN Data Missing for Row:", params.data);
      return ''; // Return empty if no HSN data
    }

    const { HSN } = params.data;
    let hsnCodes = [];

    // Extract codes from bzgddtls
    if (HSN.bzgddtls && HSN.bzgddtls.length > 0) {
      hsnCodes = hsnCodes.concat(HSN.bzgddtls.map(item => item.hsncd));
    }

    // Extract codes from bzsdtls
    if (HSN.bzsdtls && HSN.bzsdtls.length > 0) {
      hsnCodes = hsnCodes.concat(HSN.bzsdtls.map(item => item.saccd));
    }

    const formattedHSN = `{${hsnCodes.join(', ')}}`;
    console.log("Formatted HSN Codes:", formattedHSN); // Log the formatted output
    return formattedHSN; // Wrap all codes in one set of curly braces
  }

  const currentWorkspace = localStorage.getItem('currentWorkspace');
  const userRole = localStorage.getItem("role");

  console.log(userRole,"user role check")

  const getServerSideDatasourceContactDetails = () => {
    console.log("Inside server side function")
    const currentWorkspace = localStorage.getItem('currentWorkspace');
    // const workSpace=workspace
    return {
      getRows: async (gridParams) => {
        console.log("[Datasource] - rows requested by grid: ", gridParams.request);





        const requestBody = {

          ...gridParams.request,



          database: "gstservice",
          // table:"all_vendor_tally_data_distinct",
          // table:"all_vendor_tally_data_spark_rebuild",
          table: "vendor_contact_details",
          // table:"all_vendor_tally_data_test",
          workspaceid: currentWorkspace,

        };
        console.log("Request body:", requestBody);
        try {
          const response = await fetch(API_ENDPOINT_CONTACT_DETAILS, {
            // const response = await fetch("http://localhost:7000/api/finalytics/tables/data/contactDetails", {

  
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
          });

          const data = await response.json();
          console.log("Data fetched:", data);




          // if (data && Array.isArray(data.data.rows)) {
          console.log("Rows from API:", data.data.rows)

          gridParams.success({ rowData: data.data.rows })

        } catch (error) {
          console.error("Error fetching server-side data:", error);
          gridParams.fail();
        }
      },
    };
  };

  const [rowData, setRowData] = useState([]);


  const onGridReady = (params) => {
    gridApiRef.current = params.api;

    const datasource = getServerSideDatasourceContactDetails();
    params.api.setServerSideDatasource(datasource);
  };


  const navigate = useNavigate()

  const [isUploadContactsModalOpen, setUploadContactsModalOpen] = useState(false);


  const openUploadContactsModal = () => {
    if (userRole !== "ADMIN") {
      setAccessDeniedModalVisible(true); // Show access denied modal
      return;
    }
    setUploadContactsModalOpen(true); // Open the Upload Contacts modal for admin users
  };

  const closeUploadContactsModal = () => setUploadContactsModalOpen(false);


  const goBack = () => {
    navigate(-1); // This will navigate the user back to the previous page
  };

  const defaultColDef = {
    filter: true,
    sortable: true,
    enableRowGroup: true,
    floatingFilter: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter'

  };


  const [vendorGstinList, setVendorGstinList] = useState([]); // State to store vendor and GSTIN list

  const onSelectionChanged = () => {
    const gridApi = gridApiRef.current;
    if (!gridApi) return; // Check if gridApi is defined

    // Get the selected rows
    const selectedRows = gridApi.getSelectedRows();
    // setSelectedRowsCount(selectedRows.length);

    // Extract vendor name and GSTIN as a list of objects
    const extractedList = selectedRows.map(vendorData => ({
      vendorName: vendorData.vendorName, // Adjust field path as needed
      gstin: vendorData.gstin,
      contactEmail: vendorData.contactEmail
    }));

    console.log('extractedList', extractedList)

    // Update state with the extracted list
    setVendorGstinList(extractedList);

    // Update button text based on selection
    if (selectedRows.length > 0) {
      // setSelectAllText("Request E-Invoice");
    } else {
      // setSelectAllText("Select All");
    }
  };

  const handleSubmitFile = (file) => {
    console.log("File submitted:", file);

    // Process the response data (file.data contains the rows from the file)
    const updatedVendorData = vendorData.map((vendor) => {
      // Check if the current vendor matches the formData (this could be one of the rows from file)
      const match = file.data.find(
        (row) => vendor.gstin === row.gstin && vendor.enablement?.legalNm === row.vendorName
      );



      if (match) {
        console.log("Match found for:", { vendor, match });

        // If match is found and the contact is not 'Completed', update it
        if (vendor.contact !== "Completed") {
          console.log(`Updating vendor with GSTIN: ${vendor.gstin}, Vendor Name: ${vendor.enablement?.legalNm}`);
          return { ...vendor, contact: "Completed" }; // Update the 'contact' field
        }
      }

      return vendor; // Keep other vendors unchanged
    });

    console.log(updatedVendorData,"updatedVendorData")

    // Update the state with the modified vendorData
    setVendorData(updatedVendorData);

    // // Add the entire file.data (contact details) to the contactData state
    // setContactData((prevContactData) => [
    //   ...prevContactData,
    //   ...file.data
    // ]);


    // Close the modal
    setUploadContactsModalOpen(false); // Close the modal after update
  };

  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const [gstin, setGstin] = useState(null); // State to store ctin


  const gridOptions = {
    sideBar: {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          minWidth: 225,
          maxWidth: 225,
          width: 225,
        },
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
          minWidth: 180,
          maxWidth: 400,
          width: 250,
        },
        // {
        //   id: "pdf viewer",
        //   labelDefault: "View",
        //   labelKey: "view",
        //   iconKey: "pdfIcon",
        //   toolPanel: "agFiltersToolPanel",
        //   minWidth: 180,
        //   maxWidth: 400,
        //   width: 250,
        // },
      ],
      position: "right",
    },

    icons: {
      pdfIcon: `<svg xmlns="https://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M10.377 11.2188L10.3828 11.1914C10.4961 10.7246 10.6387 10.1426 10.5273 9.61523C10.4531 9.19922 10.1465 9.03711 9.88477 9.02539C9.57617 9.01172 9.30078 9.1875 9.23242 9.44336C9.10352 9.91211 9.21875 10.5527 9.42969 11.3691C9.16406 12.002 8.74023 12.9219 8.42969 13.4688C7.85156 13.7676 7.07617 14.2285 6.96094 14.8105C6.9375 14.918 6.96484 15.0547 7.0293 15.1777C7.10156 15.3145 7.2168 15.4199 7.35156 15.4707C7.41016 15.4922 7.48047 15.5098 7.5625 15.5098C7.90625 15.5098 8.46289 15.2324 9.20508 13.959C9.31836 13.9219 9.43555 13.8828 9.54883 13.8438C10.0801 13.6641 10.6309 13.4766 11.1289 13.3926C11.6797 13.6875 12.3066 13.877 12.7324 13.877C13.1543 13.877 13.3203 13.627 13.3828 13.4766C13.4922 13.2129 13.4395 12.8809 13.2617 12.7031C13.0039 12.4492 12.377 12.3828 11.4004 12.5039C10.9199 12.2109 10.6055 11.8125 10.377 11.2188ZM8.23438 14.1855C7.96289 14.5801 7.75781 14.7773 7.64648 14.8633C7.77734 14.623 8.0332 14.3691 8.23438 14.1855ZM9.94531 9.58594C10.0469 9.75977 10.0332 10.2852 9.95508 10.5508C9.85938 10.1621 9.8457 9.61133 9.90234 9.54688C9.91797 9.54883 9.93164 9.56055 9.94531 9.58594ZM9.91406 11.9395C10.123 12.3008 10.3867 12.6113 10.6777 12.8418C10.2559 12.9375 9.87109 13.0957 9.52734 13.2363C9.44531 13.2695 9.36523 13.3027 9.28711 13.334C9.54688 12.8633 9.76367 12.3301 9.91406 11.9395ZM12.9531 13.2188C12.9551 13.2227 12.957 13.2285 12.9453 13.2363H12.9414L12.9375 13.2422C12.9219 13.252 12.7617 13.3457 12.0723 13.0742C12.8652 13.0371 12.9512 13.2168 12.9531 13.2188ZM16.6914 5.63672L12.4883 1.43359C12.3711 1.31641 12.2129 1.25 12.0469 1.25H3.75C3.4043 1.25 3.125 1.5293 3.125 1.875V18.125C3.125 18.4707 3.4043 18.75 3.75 18.75H16.25C16.5957 18.75 16.875 18.4707 16.875 18.125V6.08008C16.875 5.91406 16.8086 5.75391 16.6914 5.63672ZM15.4336 6.36719H11.7578V2.69141L15.4336 6.36719ZM15.4688 17.3438H4.53125V2.65625H10.4297V6.875C10.4297 7.09256 10.5161 7.30121 10.67 7.45505C10.8238 7.60889 11.0324 7.69531 11.25 7.69531H15.4688V17.3438Z" fill="black" fill-opacity="0.45"/>
      </svg>`,
    },
  };

  const closeSideMenu = () => {
    setIsSideMenuOpen(false); // Close the side menu
    // setSelectedVendor(null);
  };


  const [invoicesData, setInvoicesData] = useState({
    totalInvoices: 0,
    receivedInvoices: 0,
    notReceivedInvoices: 0,
    receivedPercentage: 0,
    notReceivedPercentage: 0
  });

  const [totalGstAmount, setTotalGstAmount] = useState('')
  const calculateInvoiceData = (ctin) => {
    // Filter rowData to get all invoices for the selected GSTIN
    const invoicesForGstin = rowData.filter((row) => row.ctin === ctin);

    // Calculate total number of invoices
    const totalInvoices = invoicesForGstin.length;

    // Calculate number of invoices received and not received
    const receivedInvoices = invoicesForGstin.filter((row) => row.invoiceStatus === "Invoice Received").length;
    const notReceivedInvoices = invoicesForGstin.filter((row) => row.invoiceStatus === "Invoice Not Received").length;

    // Calculate percentages
    const receivedPercentage = totalInvoices > 0 ? (receivedInvoices / totalInvoices) * 100 : 0;
    const notReceivedPercentage = totalInvoices > 0 ? (notReceivedInvoices / totalInvoices) * 100 : 0;

    // Return the invoice data
    return {
      totalInvoices,
      receivedInvoices, // Count of received invoices
      notReceivedInvoices, // Count of not received invoices
      receivedPercentage,
      notReceivedPercentage
    };
  };

  const handleCellClick = (event) => {

    // const selectRow=gridApi.getSelectedRows();
    // setSelectedRow(selectRow)
    // console.log(selectRow,"selected row")


    const { colDef, data } = event;
    console.log("data in hanlde cell click", data)

    if (colDef.field === "vendorName") {

      const { gstin, totalGstAmount } = data;
      console.log("ctin", gstin);

      // Calculate invoice data for the selected GSTIN
      const invoiceData = calculateInvoiceData(gstin);
      console.log(invoiceData)

      setGstin(gstin);
      setTotalGstAmount(totalGstAmount)
      setInvoicesData(invoiceData); // Set the calculated data
      setIsSideMenuOpen(true); // Open the side menu

      // navigate(`/vendorfollowup/vendorscore?vendorName=${vendorName}&pan=${pan}&ctin=${ctin}`);
    }

  };

  const [isAccessDeniedModalVisible, setAccessDeniedModalVisible] = useState(false);


  return (
    <div className="vendor-management" style={{ display: 'flex' }}>
      <div>
        <PrimaryNavBhilosa />
      </div>
      <div style={{ width: '100%', marginTop: '20px' }}>
        <Modal
          title="Access Denied"
          open={isAccessDeniedModalVisible}
          onOk={() => setAccessDeniedModalVisible(false)}
          onCancel={() => setAccessDeniedModalVisible(false)}
          centered
        >
          <p>Admin access is required for this feature.</p>
        </Modal>

        <header className="vendor-header">
          <div className="vendor-left">
            <h1 style={{ marginLeft: '10px' }}>Contact Details</h1>



          </div>
          <div className="vendor-right">

            <button
              onClick={openUploadContactsModal}
              className="vendor-btn"
              style={{
                display: 'inline-flex',  // Align items horizontally
                alignItems: 'center',    // Vertically align items in the center
                backgroundColor: 'white',
                border: '1px solid #0a8394',
                color: '#0a8394',
                padding: '8px 12px',
                paddingLeft: '10px',
                borderRadius: '5px',
                fontSize: '14px',
                marginLeft: '10px',
                cursor: 'pointer',
                gap: '5px',              // Adds space between the icon and the text
                transition: 'background-color 0.3s ease'
              }}
            >
              <svg xmlns="https://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <path d="M10.5001 4.16666V15.8333M4.66675 9.99999H16.3334" stroke="#0A8394" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Add Contact
            </button>
          </div>
        </header>

        <div className="ag-theme-alpine" style={{ height: '90vh', width: "100%", marginTop: '20px' }}>
          <AgGridReact
            columnDefs={columnDefsContactDetails}
            rowModelType="serverSide"
            gridOptions={gridOptions}
            onGridReady={onGridReady}
            onSelectionChanged={onSelectionChanged}
            rowSelection="multiple"
            animateRows={true}
            defaultColDef={defaultColDef}
            groupPanel
            onCellClicked={handleCellClick}
            rowGroupPanelShow="always"
            enableSorting={true}
            enableFilter={true}
            masterDetail={true}
            groupSelectsChildren={true}
          />
        </div>
        <UploadContactsModal
          isOpen={isUploadContactsModalOpen}
          onClose={closeUploadContactsModal}
          onSubmit={handleSubmitFile}
          selectedVendorNamesAndGstin={vendorGstinList}
          sampleCsvPath="/vendor_contact_details.csv"
        />
        {isSideMenuOpen && (
          <div className="side-menu">
            <button className="close-btn" onClick={closeSideMenu}>
              &times;
            </button>
            <MainContentVendor gstin={gstin} workspace={workspace_name} />
          </div>
        )}
      </div>

    </div>
  );
};

export default ContactDetailsTable;
